import { ContextMenu } from 'craft/types';

import { SET_CONTEXT_MENU } from './constants';

export const setContextMenu = (contextMenu?: ContextMenu) => ({
  type: SET_CONTEXT_MENU,
  contextMenu,
});
